import React from 'react';
import {
  Box,
  Typography,
  Button,
  Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface BonusProgramInfoProps {
  open: boolean;
  onClose: () => void;
  clinicData: any;
}

export const BonusProgramInfo: React.FC<BonusProgramInfoProps> = ({
  open,
  onClose,
  clinicData,
}) => {
  const points = clinicData?.points || {};

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          maxWidth: '359px',
          bgcolor: '#ffffff',
          borderRadius: '24px',
          maxHeight: '85vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          pb: 2.5,
        }}
      >
        {/* Close Button */}
        <Button
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            minWidth: 'auto',
            p: 0.5,
            color: '#212121',
            zIndex: 10,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          }}
        >
          <CloseIcon sx={{ fontSize: '24px' }} />
        </Button>

        {/* Content */}
        <Box sx={{ p: 2.5, pt: 4 }}>
          {/* Main Title */}
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 600,
              color: '#212121',
              mb: '23px',
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            Бонусная программа
          </Typography>

          {/* Section 1 - Оплата бонусами */}
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#007AFF',
              mb: '16px',
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            Оплата бонусами
          </Typography>

          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              color: '#212121',
              lineHeight: 1.2,
              mb: '24px',
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            Бонусами можно оплатить до {points.pointsMaxPercentForPayment}% всех покупок (1 балл = 1 руб.). По нашей программе лояльности вы также получаете {points.pointsPercentForPay}% от суммы чека обратно на счёт.
          </Typography>

          {/* Section 2 - Как получить баллы */}
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#007AFF',
              mb: '16px',
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            Как получить баллы?
          </Typography>

          {/* Benefits List */}
          <Box sx={{ mb: '24px' }}>
            {points.pointsForRecommend > 0 && (
              <Box sx={{ display: 'flex', gap: '6px', mb: '12px', alignItems: 'flex-start' }}>
                <Typography
                  sx={{
                    fontSize: '18px',
                    color: '#212121',
                    mt: -0.2,
                    minWidth: '16px',
                    textAlign: 'center',
                    fontWeight: 600,
                    flexShrink: 0,
                  }}
                >
                  -
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#212121',
                    lineHeight: 1.2,
                    fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  }}
                >
                  Рекомендуйте клинику своим друзьям и получайте {points.pointsForRecommend} баллов за каждого, кто пришел по вашему совету;
                </Typography>
              </Box>
            )}

            {points.pointsForReviewBranch > 0 && (
              <Box sx={{ display: 'flex', gap: '6px', mb: '12px', alignItems: 'flex-start' }}>
                <Typography
                  sx={{
                    fontSize: '18px',
                    color: '#212121',
                    mt: -0.2,
                    minWidth: '16px',
                    textAlign: 'center',
                    fontWeight: 600,
                    flexShrink: 0,
                  }}
                >
                  -
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#212121',
                    lineHeight: 1.2,
                    fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  }}
                >
                  Оставляйте отзывы на картах или ПроДокторов — и мы начислим {points.pointsForReviewBranch} баллов
                </Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', gap: '6px', alignItems: 'flex-start' }}>
              <Typography
                sx={{
                  fontSize: '18px',
                  color: '#212121',
                  mt: -0.2,
                  minWidth: '16px',
                  textAlign: 'center',
                  fontWeight: 600,
                  flexShrink: 0,
                }}
              >
                -
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#212121',
                  lineHeight: 1.2,
                  fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                }}
              >
                Получайте кешбэк за каждую покупку в размере {points.pointsPercentForPay}%
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Close Button Bottom */}
        <Box
          sx={{
            px: 2.5,
            pb: 2,
            mt: 'auto',
          }}
        >
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              bgcolor: '#007AFF',
              color: '#ffffff',
              fontSize: '16px',
              fontWeight: 600,
              height: '56px',
              borderRadius: '24px',
              width: '100%',
              textTransform: 'none',
              transition: 'all 0.2s ease',
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              '&:hover': {
                bgcolor: '#0055CC',
                boxShadow: '0 8px 24px rgba(0, 122, 255, 0.3)',
              },
            }}
          >
            Закрыть
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
